import React from 'react';

const NoSampleSelected = () => {
    return <div className='flex flex-1 items-center justify-center bg-white rounded-md'>Select a sample on the left</div>;
};

export default NoSampleSelected;
